import { render } from "./vhp3dViewer.vue?vue&type=template&id=d5b1aece"
import script from "./vhp3dViewer.vue?vue&type=script&lang=js"
export * from "./vhp3dViewer.vue?vue&type=script&lang=js"

import "./vhp3dViewer.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__